export const NavigationType = {
    Admin: "admin",
    BatchUser: "batchUser",
    ShippingOrderUser: "shippingOrderUser",
    ShippingUser: "shippingUser"
} as const;

export type NavigationType = (typeof NavigationType)[keyof typeof NavigationType];
